import React, { useContext, useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ApprovalsTable from "./table";
import { Box, Button, CircularProgress } from "@mui/material";
import ApiServices from "../../services";
import AppContext from "../../contexts/appContext";
import handleError from "../../services/handleError";
import { Add } from "@mui/icons-material";

export default function HomePage() {
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const {
    state: { auth },
    dispatch
  } = useContext(AppContext);

  useEffect(() => {
    if (!auth.token) {
      return;
    }
    setloading(true);
    ApiServices.getApprovalsList({ token: auth.token })
      .then((res) => {
        if (res.success === true) {
          setdata(res.payload);
          setloading(false);
        } else {
          setloading(false);
          handleError(res.code, dispatch);
        }
      })
      .catch((err) => {
        console.error("===> Error response : ", err);
        setloading(false);
      });
    return () => {};
  }, []);

  const handleCreateApproval = () => {
    navigate("/app/approvals/create");
  };

  return (
    <div style={{ padding: 16 }}>
      <div className="main-title-wrapper" style={{marginBottom: '32px'}}>
        <h1 className="main-title" style={{margin: 0}}>
          <Trans>sidenav.activity.approvals</Trans>
        </h1>
        <Button
          className="create_approval_btn"
          variant="contained"
          color="primary"
          aria-label="create new"
          startIcon={<Add />}
          style={{
            boxShadow: "none",
            alignSelf: "center",
            marginInlineStart: "auto",
          }}
          onClick={handleCreateApproval}
        >
          <span className="text">Create New</span>
        </Button>
      </div>
      
      {loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center", minHeight: "100vh" }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <ApprovalsTable data={data} />
      )}
    </div>
  );
}
